module.exports = __webpack_public_path__ + "img/shopping-basket-2-fill.15ccabff.svg";